import * as CryptoJS from './crypto-js.min';

export const encrypt = (data) =>  {
  const secretKey = window.tc_vars.user_id_1id;
  data = CryptoJS.AES.encrypt(data, secretKey);
  data = data.toString();
  return data;
};

export const decrypt = (data) => {
  const secretKey = window.tc_vars.user_id_1id;
  data = CryptoJS.AES.decrypt(data, secretKey);
  data = data.toString(CryptoJS.enc.Utf8);
  return data;
};



// WEBPACK FOOTER //
// ./src/_override/context/cryptoService.js